// Inline spinner used for in-panel loading.
export function Spinner({ size = 22 }) {
  return <span className="spinner" style={{ width: size, height: size }} aria-label="loading" />;
}

// Centered block loader for whole-page / panel loading states.
export function Loading({ label = 'Loading…' }) {
  return (
    <div className="loading-block">
      <Spinner size={28} />
      <span>{label}</span>
    </div>
  );
}

// Full-screen splash shown while the app boots (fund list loading).
export function Splash({ label = 'Loading Blue Aster MIS…' }) {
  return (
    <div className="splash">
      <img src="/logo.png" alt="Blue Aster Capital" className="splash-logo" />
      <Spinner size={30} />
      <div className="splash-label">{label}</div>
    </div>
  );
}
